const isDev = window.location.hostname === "localhost";

const config = {
  API_BASE: isDev
    ? `${window.location.origin}/vybertech/api`
    : `${window.location.origin}/api`,
  UPLOADS_URL: isDev
    ? `${window.location.origin}/vybertech/uploads`
    : `${window.location.origin}/uploads`,
  SHOP_UPLOADS_URL: isDev
    ? `${window.location.origin}/vybertech/uploads/shop_products`
    : `${window.location.origin}/uploads/shop_products`,
};

export default config;